import { useService } from 'react-reservice';

import { ISymbol } from '@aqx-core/common/api/market';

import { omitProperties, pickProperties } from '../../utils';
import { tradeWatchlistService } from './service';

export const useTradeWatchlistSymbols = () =>
  useService(tradeWatchlistService, (context) => Object.values(context.displayWatchlistSymbols));

export const useTradeWatchlistSymbolIds = () =>
  useService(tradeWatchlistService, (context) => context.displayWatchlistSymbolIds);

export const useTradeWatchlistSymbol = (id: string): Partial<ISymbol> =>
  useService(tradeWatchlistService, (context) => context.displayWatchlistSymbols[id] || {});

export const useTradeWatchlistSymbolWithoutPrice = (id: string): Partial<ISymbol> =>
  useService(tradeWatchlistService, (context) => {
    const symbol = context.displayWatchlistSymbols[id];
    if (!symbol) {
      return {};
    }
    return omitProperties(symbol, ['ask']);
  });

export const useTradeWatchlistSymbolWithPrice = (id: string): Pick<ISymbol, 'bid' | 'decimal'> =>
  useService(tradeWatchlistService, (context) => {
    const symbol = context.displayWatchlistSymbols[id];
    if (!symbol) {
      return {} as Pick<ISymbol, 'bid' | 'decimal'>;
    }
    return pickProperties(symbol, ['bid', 'decimal']);
  });

export const useSelectedWatchListFilter = () =>
  useService(tradeWatchlistService, (context) => context.selectedWatchListFilter);

export const useSelectedSymbolCategory = () =>
  useService(tradeWatchlistService, (context) => context.selectedSymbolCategory);

export const useAllSymbolsCategories = () => useService(tradeWatchlistService, (context) => context.symbolCategories);

export const useShouldRefetchFavourites = () =>
  useService(tradeWatchlistService, (context) => context.shouldRefetchFavourites);

export const useWatchlistLoading = () => {
  return useService(tradeWatchlistService, (context) => context.watchlistLoading);
};
